module.exports = __webpack_public_path__ + "fonts/NunitoSans-Black.f19a3af.ttf";